module.exports = __webpack_public_path__ + "img/new-blood.72a58b28.jpg";